<template>
  <div class="my-message all-order-content">
    <div class="breadcrumb" style="margin-bottom: 20px;">首页banner</div>
    <div class="right-content">
      <el-form ref="bannerForm" label-width="160px" :model="bannerForm" class="demo-form-inline">
        <!-- <el-form-item label="上传banner图片：" prop="bannerUrl">
          <el-upload :class="{ hide_uploadbtn: bannerForm.bannerUrl.length > 0 }" action="#" list-type="picture-card" accept='image/jpeg' :on-preview="showAppImagePreview('ban')"
            :on-remove="(e) => removeAppImage(e, 'ban')" :file-list="bannerForm.bannerUrl" :http-request="(e) => uploadAppImage(e, 'ban')" :multiple="false" :limit="1">
            <i class="el-icon-plus"></i>
          </el-upload>
          <p style="color: #999;line-height: 22px;">建议尺寸1920*1080，内存不得超过2M,数量不限循环播放</p>
        </el-form-item> -->
        <el-form-item label="上传banner图片：" prop="detailsUrl">
          <el-upload action="#" list-type="picture-card" accept='image/jpeg' :on-preview="showAppImagePreview('banDetail')" :on-remove="(e) => removeAppImage(e, 'banDetail')"
            :file-list="bannerForm.detailsUrl" :http-request="(e) => uploadAppImage(e, 'banDetail')" :multiple="true" :before-upload="(e) => handleBeforeUpload(e, 'image')">
            <i class="el-icon-plus"></i>
          </el-upload>
          <p style="color: #999;line-height: 22px;">建议尺寸1920*1080，内存不得超过2M,数量不限循环播放</p>
        </el-form-item>
        <el-form-item label="视频:">
          <div style="display:flex">
            <div class="avatar" v-for='(item, index) in bannerForm.videoUrl' :key='index'>
              <video id="video" v-bind:src="item.url" class="avatar video-avatar" controls="controls" @canplaythrough="myFunction($event)" style="margin-right:20px"> 您的浏览器不支持视频播放 </video>
              <div class="delete" @click="removeVideo(index, item)">×</div>
            </div>
            <el-upload action="#" accept='.mp4, .avi' v-loading="loading" :http-request="(e) => httpRequest(e)" :before-upload="(e) => handleBeforeUpload(e, 'video')" :show-file-list="false">
              <div class="picture-card"><i class="el-icon-plus" style="font-size:28px"></i></div>
            </el-upload>
          </div>
          <p style="color: #999;line-height: 22px;">内存不得超过2M,数量不限循环播放</p>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveBanner" round>确 定</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import $ from 'jquery'
import uploadWebImg from '@/utils/uploadWebImg'
import { getBannerDetail, bannerSave, batchRemove } from '@/api/crm'
import { resolve } from 'path'
export default {
  name: 'banner-detail',
  data () {
    return {
      systemCode: '',
      loading: false,
      bannerForm: {
        type: '',
        associationId: '',
        associationName: '',
        videoUrl: [],
        detailsUrl: []
      },
      tableDataList: []
    }
  },
  watch: {
    $route: {
      handler: function (newRoute, oldRoute) {
        console.log('当前路由：', newRoute)
        console.log('之前的路由：', oldRoute)
        if (newRoute.path == '/piya/banner') {
          this.systemCode = 'PIYA'
        } else {
          this.systemCode = ''
        }
        if (oldRoute && (oldRoute.path == '/piya/banner' || oldRoute.path == '/videoSeason/banner')) {
          this.getBanner()
        }
      },
      // 深度观察监听
      deep: true,
      immediate: true
    }
  },
  created () {
    if (this.$checkAwsSdk('product')) {
      this.$store.dispatch('awsSdk/getAwsSdk', 'product')
    }
    this.getBanner()
  },
  methods: {
    // 上传之前
    handleBeforeUpload (file, type) {
      if (type == 'video') {
        if (['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb', 'video/mov'].indexOf(file.type) === -1) {
          this.$message.warning('请上传正确的视频格式')
          return false
        }
      }
      if (file.size > 1024 * 1024 * 2) {
        this.$message.error('图片大小不能超过2M')
        return false
      }
    },
    removeVideo (index, item) {
      if (!item.id) {
        this.bannerForm.videoUrl.splice(index, 1)
      } else {
        this.deleteBanner(item.id)
      }
    },
    deleteBanner (id) {
      batchRemove([id]).then(a => {
        if (a.data.success) {
          this.$notify({
            title: '成功',
            message: '删除成功',
            type: 'success'
          })
          this.getBanner()
        }
      })
    },
    myFunction () {
      let ele = $('#video')
      let _this = this
      // var hour = parseInt((ele.duration) / 3600)
      // var second = Math.ceil(ele.duration % 60)
      var i = setInterval(function () {
        // if (ele.readyState > 0) {
        var minutes = parseInt(ele[0].duration / 60, 10)
        if (minutes > 0) {
          _this.$message.error('视频时长不能超过60s')
          _this.basicInfo.spuVideo.url = ''
        }
        clearInterval(i)
        // }
      }, 200)
    },
    // 上传产品phone端详情图片
    uploadPhoneDetailImg (e) {
      if (e.file.type !== 'image/jpeg' && e.file.type !== 'image/png') {
        this.$message.error('请上传jpeg/png格式的图片')
        return
      }
      if (e.file.size > 1024 * 1024 * 10) {
        this.$message.error('图片大小不能超过10M')
        return
      }
      uploadWebImg(e.file, this.$store.state.awsSdk.product.s3).then(res => {
        // 获取富文本组件实例
        let quill = this.$refs.phoneQuillEditor.quill
        // 如果上传成功
        if (res) {
          let length = quill.getSelection().index
          quill.insertEmbed(length, 'image', res)
          quill.setSelection(length + 1)
        } else {
          this.$message.error('图片插入失败')
        }
      })
    },
    removeAppImage (val, type) {
      // this.bannerForm.bannerUrl = []
      if (!val.id) {
        this.bannerForm.detailsUrl = this.bannerForm.detailsUrl.filter(a => a.uid !== val.uid)
      } else {
        this.deleteBanner(val.id)
      }
      console.log('bannerForm.detailsUrl', this.bannerForm.detailsUrl)
      // this.bannerForm.bannerUrl = ''
    },
    showAppImagePreview (type) {
      this.showImgPreview = true
      this.previewImage = this.bannerForm.bannerUrl
    },
    uploadAppImage (e, type) {
      uploadWebImg(e.file, this.$store.state.awsSdk.product.s3).then(res => {
        if (res) {
          if (type == 'banDetail') {
            console.log('res', res)
            this.bannerForm.detailsUrl.push({ url: res })
          }
          this.showPcImage = false
          this.$refs.bannerForm.validateField('bannerUrl')
        } else {
          this.$message.error('图片上传失败')
        }
      })
    },
    // 视频上传前回调
    beforeUploadVideo (file) {
      // var fileSize = file.size / 1024 / 1024 < 50
      if (['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb', 'video/mov'].indexOf(file.type) === -1) {
        this.$message.warning('请上传正确的视频格式')
        return false
      }
      this.isShowUploadVideo = false
    },
    httpRequest (data) {
      this.loading = true
      uploadWebImg(data.file, this.$store.state.awsSdk.product.s3, [], () => { }, 150, 150).then(res => {
        this.bannerForm.videoUrl.push({ url: res })
        this.loading = false
      })
    },
    saveBanner () {
      if (this.bannerForm.detailsUrl.length < 1) {
        this.$message.error('请上传banner图！')
        return
      }
      let detailsUrl = this.bannerForm.detailsUrl?.filter(a => !a.id)
      let detailsUrls = detailsUrl.map(a => {
        return {
          bannerUrl: a.url,
          type: 1
        }
      })
      let videoUrl = this.bannerForm.videoUrl?.filter(a => !a.id)
      let videoUrls = videoUrl.map(a => {
        return {
          bannerUrl: a.url,
          type: 2
        }
      })
      let loginBannerVos = detailsUrls.concat(videoUrls)
      if (loginBannerVos.length > 0) {
        bannerSave({ loginBannerVos }).then(res => {
          if (res.data.success) {
            this.$notify({
              title: '成功',
              message: '保存成功',
              type: 'success'
            })
            this.getBanner()
          }
        })
      } else {
        this.$notify({
          title: '成功',
          message: '保存成功',
          type: 'success'
        })
      }
    },
    getBanner () {
      getBannerDetail({ systemCode: this.systemCode }).then((res) => {
        if (res.data.success) {
          let videoUrlList = res.data.data.filter(a => a.type == 2)
          this.bannerForm.videoUrl = videoUrlList.map(a => {
            return { url: a.bannerUrl, id: a.id }
          })
          let detailsUrlList = res.data.data.filter(a => a.type == 1)
          this.bannerForm.detailsUrl = detailsUrlList.map(a => {
            return {
              url: a.bannerUrl,
              id: a.id
            }
          })
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
@deep: ~">>>";

/deep/ .el-upload-list__item-thumbnail {
  // width: auto !important;
  object-fit: scale-down;
}

@{deep} .pc_detail {
  width: 100%;

  img {
    width: 100%;
  }
}

@{deep} .hide_uploadbtn .el-upload--picture-card {
  display: none;
  /* 上传按钮隐藏 */
}

.picture-card {
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  box-sizing: border-box;
  width: 148px;
  height: 148px;
  cursor: pointer;
  line-height: 146px;
  vertical-align: top;
}

.avatar {
  position: relative;
  width: 148px;
  height: 148px;
  margin-right: 10px
}

.video-avatar {
  width: 148px;
  height: 148px;
}

.delete {
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  z-index: 9999;
  color: #aaa;
  position: absolute;
  top: 0;
  right: 0;
  border: 1px solid #aaa;
  border-radius: 10px;
  cursor: pointer;
}

// @{deep} .ql-container .ql-snow {
//   height: 500px;
// }
@{deep} .ql-container {
  height: auto !important;
}

.quill-editor {
  width: 70%;

  @{deep} .ql-editor {
    min-height: 400px;
  }

  @{deep} .ql-toolbar {
    .ql-picker-label {
      height: auto;
    }

    .ql-picker.ql-expanded .ql-picker-options {
      top: auto;
    }
  }
}

@{deep} .el-cascader {
  line-height: 0;
}
</style>
